var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpression(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1725",
    "data-name": "Rectangle 1725",
    width: 16.187,
    height: 19.74,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_1:_First_Impression",
    "data-name": "Stage 1: First Impression",
    transform: "translate(-592 -301.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_680",
    "data-name": "Ellipse 680",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592 301.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32051",
    "data-name": "Group 32051",
    transform: "translate(599 305.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32050",
    "data-name": "Group 32050",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13518",
    "data-name": "Path 13518",
    d: "M15.538,12.245a1.081,1.081,0,0,0-1.066,1.066,1.066,1.066,0,1,0,1.066-1.066",
    transform: "translate(-1.69 -1.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13519",
    "data-name": "Path 13519",
    d: "M7.356.834a.539.539,0,0,1,.762.762,1.082,1.082,0,0,0,0,1.525,2.163,2.163,0,0,1,0,3.052.566.566,0,0,1-.382.153.518.518,0,0,1-.381-.153.539.539,0,0,1,0-.762,1.06,1.06,0,0,0,.026-1.5l-.026-.026a2.161,2.161,0,0,1,0-3.052M5.162.153a.54.54,0,0,1,.763.763,1.082,1.082,0,0,0,0,1.525,2.187,2.187,0,0,1,0,3.07.566.566,0,0,1-.382.153.515.515,0,0,1-.382-.153.541.541,0,0,1,0-.762,1.082,1.082,0,0,0,0-1.525A2.155,2.155,0,0,1,5.139.176L5.162.153m8.711,14.036a2.3,2.3,0,0,1-1.221-.353A6.794,6.794,0,0,1,9.9,18.5h2.2a.622.622,0,1,1,0,1.244H.622a.622.622,0,0,1,0-1.244H2.84A7.014,7.014,0,0,1,0,13.148V8.263a.618.618,0,0,1,.618-.618H12.1a.618.618,0,0,1,.618.618v1.55a2.44,2.44,0,0,1,1.131-.289,2.33,2.33,0,1,1,.023,4.661",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpression);
export default __webpack_public_path__ + "static/media/impression.7736989829739533c7b049b0dc6b1014.svg";
export { ForwardRef as ReactComponent };